// Literal UI labels from the frozen Will v1 definition; no response data or answer keys.
export const SURVEY_SOURCE_SHA = "3e0c4fd1b773ee0588352c515cb4612363964b78b618661c93ac677d978ef16a";
export const SURVEY_QUESTION_LABELS: Record<string, string> = {
  "q6": "I could explain to a colleague, in plain terms, how a tool like ChatGPT produces its answers.",
  "q7": "I understand what AI means for how pupils are assessed in my area of the school.",
  "q8": "I know the main ways AI tools get things wrong, and how to check what they produce.",
  "q9": "Before using an AI tool, I know what information I can and cannot put into it.",
  "q10": "I know who to go to in school when AI raises a safeguarding or data protection concern.",
  "q11": "I know which AI tools my school has approved for staff use.",
  "q12": "I use AI in ways that are specific to my subject or role, beyond generic tasks.",
  "q13": "I could show a colleague one way AI has improved my work.",
  "q14": "AI has become part of how I do at least one regular task in my working week.",
  "q15": "I can recognise when using AI would take away thinking a pupil needs to do for themselves.",
  "q16": "I feel confident choosing not to use AI when it isn't the right tool for the job.",
  "q17": "I could describe a situation in my own work where I would choose not to use AI.",
  "q22": "My school has a clear position on how staff should and shouldn't use AI.",
  "q23": "I have had enough training to use AI well in my role."
};
export const WEEKLY_USE_LABELS: Record<string, string> = {
  "0": "Never",
  "1": "Less than once a week",
  "2": "About once a week",
  "3": "Several times a week",
  "4": "Daily"
};
export const TIME_SAVED_LABELS: Record<string, string> = {
  "0": "None",
  "1": "Less than 30 minutes",
  "2": "30 to 60 minutes",
  "3": "1 to 2 hours",
  "4": "More than 2 hours"
};
export const REPORTED_USE_LABELS: Record<string, string> = {
  "0": "Planning lessons or creating resources",
  "1": "Feedback, marking or assessment",
  "2": "Admin, emails and paperwork",
  "3": "Communication with parents",
  "4": "Reports, data or analysis",
  "5": "Developing my own subject or professional knowledge",
  "6": "Supporting pupils with additional needs",
  "7": "Other"
};
export const SURVEY_PRINCIPLE_LABELS: Record<string, string> = {
  "understand": "Understanding not assumptions",
  "protect": "Safety and responsible use first",
  "use": "Putting it to work in your own subject or role",
  "judge": "The confidence to say no"
};
export const SCENARIO_THEME_LABELS: Record<string, string> = {
  "q18": "Checking AI accuracy",
  "q19": "Data protection",
  "q20": "Getting better output",
  "q21": "Protecting pupil thinking"
};
